<template lang="pug">
#home
  vheader
  mobile-nav
  banner
  business
  events
  tutor
  vcontent
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import Banner from '../components/Banner.vue'
import Business from '../components/Business.vue'
import Events from '../components/Events.vue'
import Tutor from '../components/Tutor.vue'
import Vcontent from '../components/Content.vue'
import Vfooter from '../components/Vfooter.vue'

export default {
  name: 'app',
  components: {
    Vheader,
    Banner,
    Business,
    Events,
    Tutor,
    Vcontent,
    Vfooter,
    'mobile-nav': MobileNav,
  }
}
</script>

<style lang="stylus">

@import '../assets/css/var';

#home
  width 100%
  // height 100%
</style>



// WEBPACK FOOTER //
// Home.vue?12510ec0